import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class CountryCodeInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request and add the x-country-code header
    const clonedRequest = request.clone({
      setHeaders: {
        'x-country-code': environment.countryCode ?? 'AT',
      },
    });

    // Pass the cloned request to the next handler
    return next.handle(clonedRequest);
  }
}

